import { isEmpty } from '@ember/utils';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import ContactModel from 'donor-elf-web/models/contact';
import type { ValidationResult } from 'ember-changeset/types';

export default {
  name: (
    _key: string,
    newValue: string,
    _oldValue: string,
    _changes: any,
    content: ContactModel,
  ): ValidationResult => {
    if (isEmpty(newValue)) {
      return "Can't be blank";
    }
    if (content.anonymousDonor && newValue !== 'Anonymous Donors') {
      return "Can't change the name of 'Anonymous Donors' contact";
    }
    return true;
  },

  subscribeToNewsletter: (
    _key: string,
    newValue: boolean,
    _oldValue: boolean,
    changes: any,
    content: ContactModel,
  ): ValidationResult => {
    if (newValue) {
      if (
        isEmpty(assignSingleProperty(content, changes, 'address1')) ||
        isEmpty(assignSingleProperty(content, changes, 'city')) ||
        isEmpty(assignSingleProperty(content, changes, 'state')) ||
        isEmpty(assignSingleProperty(content, changes, 'zip'))
      ) {
        return "Can't subscribe to Newsletter when Street 1, City, State or Zip is blank";
      }
    }
    return true;
  },
};
